// extracted by mini-css-extract-plugin
module.exports = {"mask":"Guidance_mask__2OH8t"};